import React from "react";
import { Info } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export const PriceDisclaimer = ({ className = "" }) => {
  const { t } = useLang();
  const d = t.disclaimer;
  return (
    <div
      data-testid="price-disclaimer"
      className={`flex items-start gap-3 rounded-2xl border border-[#E8DFC9] bg-[#F7F1E3] p-4 sm:p-5 ${className}`}
    >
      <div className="w-8 h-8 rounded-lg bg-white/70 text-[#1E4D2B] flex items-center justify-center flex-shrink-0">
        <Info size={16} />
      </div>
      <div className="space-y-1.5 text-xs sm:text-sm leading-relaxed text-stone-600">
        <p data-testid="price-disclaimer-text">
          <strong className="text-stone-800">{d.label}</strong> {d.text}
        </p>
        <p data-testid="price-disclaimer-source">
          <strong className="text-stone-800">{d.source_label}</strong> {d.source}
        </p>
      </div>
    </div>
  );
};
